export default {
    read_all: 'Читать все отзывы',
}
